<template>
	<div
		class="empty-library-container"
		:style="containerStyle"
	>

		<div class="album-book">
			<div class="book-back"></div>
			<div class="book-cover">
				<div class="cover-content">
					<div class="photo-grid">
						<div class="grid-cell"></div>
						<div class="grid-cell"></div>
						<div class="grid-cell"></div>
						<div class="grid-cell"></div>
						<div class="grid-cell"></div>
						<div class="grid-cell"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'EmptyPhotoLibrary',
	props: {
		size: {
			type: [Number, String],
			default: 300
		}
	},
	computed: {
		containerStyle() {
			const sizeValue = typeof this.size === 'string' ? parseInt(this.size) : this.size
			const scale = sizeValue / 300 // Base size is 300px

			return {
				width: `${sizeValue}px`,
				height: `${sizeValue}px`,
				transform: `scale(${scale})`
			}
		}
	}
}
</script>

<style scoped>
.empty-library-container {
	position: relative;
	width: 300px;
	height: 300px;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
	transform-origin: center center;
}

.album-book {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%) rotateX(25deg) rotateY(-25deg);
	transform-style: preserve-3d;
}

.book-cover {
	width: 160px;
	height: 120px;
	background: linear-gradient(145deg, #3a3a3a, #2a2a2a);
	border-radius: 8px;
	position: relative;
	border: 1px solid #444;
	transform: translateZ(12px);
}

.book-back {
	position: absolute;
	width: 160px;
	height: 120px;
	background: #2a2a2a;
	border-radius: 8px;
	transform: translateZ(-12px);
	border: 1px solid #333;
}

.cover-content {
	position: absolute;
	inset: 16px;
	border: 2px dashed #555;
	border-radius: 6px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.photo-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 4px;
	width: 60px;
	height: 40px;
}

.grid-cell {
	background: transparent;
	border: 1px dashed #666;
	border-radius: 2px;
	position: relative;
	opacity: 0.6;
}

/* Animations */
.album-book {
	animation: bookFloat 8s ease-in-out infinite;
}

@keyframes bookFloat {
	0%, 100% {
		transform: translate(-50%, -50%) rotateX(25deg) rotateY(-25deg) translateY(0);
	}
	50% {
		transform: translate(-50%, -50%) rotateX(25deg) rotateY(-25deg) translateY(-8px);
	}
}

.grid-cell {
	animation: gridPulse 3s ease-in-out infinite;
}

.grid-cell:nth-child(1) { animation-delay: 0s; }
.grid-cell:nth-child(2) { animation-delay: 0.2s; }
.grid-cell:nth-child(3) { animation-delay: 0.4s; }
.grid-cell:nth-child(4) { animation-delay: 0.6s; }
.grid-cell:nth-child(5) { animation-delay: 0.8s; }
.grid-cell:nth-child(6) { animation-delay: 1s; }

@keyframes gridPulse {
	0%, 100% { opacity: 0.9; }
	50% { opacity: 0.5; }
}
</style>
